import { 
	IDictionary,
	Action
} from 'util/domain';
import { CommonUtilsService } from 'util/services';

interface DataHandle {
	uri:string;
	revoke:Action;
}
export class ObjectHandleRepository {
	public static $inject = [
		'$window',
		'$http',
		'$q',
		'utils'
	];

	private handles:IDictionary<DataHandle> = {};
	private metadata:IDictionary<IDictionary<string>> ={};

	constructor(
		private $window:ng.IWindowService,
		private $http:ng.IHttpService,
		private $q:ng.IQService,
		private utils:CommonUtilsService
	){
	}

	public create(binary:Blob, key:string = `obj-handle:${this.utils.generateUid()}`) {
		if(!(key in this.handles)){
			let uri = this.$window.URL.createObjectURL(binary); 
			this.handles[key] = {
				uri,
				revoke : this.createRevoker(key, uri)
			};
		}

		return this.handles[key].uri;
	}

	public revokeAll() {
		Object.keys(this.handles)
			.map(k => this.handles[k])
			.forEach(h => h.revoke());
	}

	public revoke(dataUri:string){
		let key = this.getKeyByUri(dataUri);
		if(!(key in this.handles)){
			throw new Error('Handle does not exist.');
		}

		this.handles[key].revoke();
	}

	/**
	 * Makes a request to the specified URI, stores the response's 
	 * binary representation memory, and returns a URI handle to it.
	 * 
	 * @param uri The URI to retrieve binary data from.
	 */
	public createFromUri(uri:string){
		const httpConfig:ng.IRequestShortcutConfig = {
			responseType: 'blob'
		};
		
		if(uri in this.handles){
			return this.$q.resolve(this.handles[uri].uri);
		}
		else {
			return this.$http
				.get<Blob>(uri, httpConfig)
				.then(resp => {
					// Use URI as a key to cache resources that could get re-requested
					// on a single view (e.g. thumbnails). This is to prevent handles 
					// from building up since data URIs aren't reused for identical blobs.
					let handle = this.create(resp.data, uri);
					this.storeMetadata(handle, resp.headers());
					return handle;
				});
		}
	}

	public getMetadata(dataUri:string){
		if(!(dataUri in this.metadata)){
			throw new Error('Metadata does not exist.');	
		}

		return this.metadata[dataUri];
	}

	private storeMetadata(handle:string, metadata:IDictionary<string>){
		this.metadata[handle] = metadata;
	}

	private createRevoker(key:string, dataUri:string){
		return () => {
			this.$window.URL.revokeObjectURL(dataUri);
			this.removeHandle(key);
			this.clearMetaData(dataUri);
		};
	}
	
	private removeHandle(key:string){
		this.handles[key] = null;
		delete this.handles[key];		
	}

	private clearMetaData(dataUri:string){
		this.metadata[dataUri] = null;
		delete this.metadata[dataUri];
	}

	private getKeyByUri(dataUri:string){
		return Object.keys(this.handles)
			.reduce((k, previous) => {
				let handle = this.handles[k];
				return handle.uri === dataUri ? k : previous;
			});
	}
}


// WEBPACK FOOTER //
// ./src/util/services/objectHandleRepository.ts